module.exports = __webpack_public_path__ + "static/media/Archive.e87b624d.png";